import { useEffect, useState } from "react"
import classnames from "classnames"

import IAlertProps from "./types"
import CloseIcon from "../../static/icons/outlined/fechar.svg"

// Components
import If from "@mobi/components/If"
import Html from "@mobi/components/Html"


// Styles
import "./Alert.scss"

const Alert = ({
  paragraph = null,
  className = "",
  closeAlert,
  icon = null,
  fadeIn = false,
  isVisible = false,
  message,
  variant = "offer",
}: IAlertProps) => {
  const [visibleState, setVisibleState] = useState(false)

  const alertBaseClass = "ds-alert"
  const alertClasses = classnames(alertBaseClass, className, {
    [`ds-alert--${variant}`]: !!variant,
    [`ds-alert--fadeIn`]: !!fadeIn,
    [`ds-alert--visible`]: visibleState,
  })

  useEffect(() => {
    setVisibleState(isVisible)
  }, [isVisible])

  return (
    <If
      condition={isVisible}
      renderIf={
        <div className={alertClasses} id="dsAlert">
          <If
            condition={icon !== null}
            renderIf={<span className={`${alertBaseClass}__icon`}>{icon}</span>}
          ></If>

          <If
            condition={paragraph !== null}
            renderIf={
              <p className={`${alertBaseClass}__text`}>{message}</p>
            }
            renderElse={
              <Html className={`${alertBaseClass}__text`}>{message}</Html>
            }
          />

          <button
            className={`${alertBaseClass}__close`}
            onClick={() => {
              closeAlert()
            }}
            aria-label="Fechar"
          >
            <CloseIcon width={25} height={25} />
          </button>
        </div>
      }
    ></If>
  )
}

export default Alert
